module.exports = __webpack_public_path__ + "a356453e0d7e2906e5d80b63ead8167d.pdf";